<template>
    <div>
        <div v-if="student !== undefined">
            <div class="row infoBox">
                <div class="col-sm-12 pt-0 pb-12">
                    <div class="d-flex justify-space-between">
                        <app-breadcrumbs
                                :backLink="`/`"
                                :text="$t('back_to_dashboard')"
                                class="infoBox"
                        ></app-breadcrumbs>
                        <div class="user-payer d-flex" v-if="accountantPerson">
                            <template v-if="accountantPerson.photo === null">
                                <img :src="env.public_base + '/assets/images/person-icon.png'" alt="">
                            </template>
                            <template v-else>
                                <img :src="accountantPerson.photo" alt="">
                            </template>
                            <div>
                                <div class="user-payer__name">{{ accountantPerson.last_name + ' ' + accountantPerson.first_name + ' ' + accountantPerson.patronymic }}</div>
                                <div class="user-payer__rang">бухгалтерка</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 pt-0 pb-0">
                    <div class="tabs-container infoBox">
                        <button type="button"
                                class="btn btn-link"
                                @click="changeTab('student_payment')"
                                :class="{'is-active': $route.name == 'student_payment'}"
                        >
                            <span>{{ $t('packages_payment') }}</span>
                        </button>
                        <button type="button"
                                class="btn btn-link"
                                @click="changeTab('history_payment')"
                                :class="{'is-active': $route.name == 'history_payment'}"
                        >
                            <span>{{ $t('payment_history') }}</span>
                        </button>
                    </div>
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import env from "../../env";
    import Breadcrumbs from "../../common_components/Breadcrumbs";

    export default {
        components: {
            appBreadcrumbs: Breadcrumbs,
        },
        data: () => ({
            env,
            test: 'test'
        }),
        computed: {
            ...mapGetters([
                'userData',
                'students_payer',
                'subscriptions_payer'
            ]),
            student() {
                return this.students_payer && this.students_payer.length ? this.students_payer.find(student => {
                    return +this.$route.params.child_id === student.id;
                }) : undefined;
            },
            accountantPerson() {
                return this.subscriptions_payer && this.subscriptions_payer.length > 0 ? this.subscriptions_payer[0].accountant : false
            }
        },
        methods: {
            studentName(firstName, lastName) {
                return firstName + ' ' + lastName;
            },
            changeTab(tab_name) {
                this.current_tab = tab_name;
                this.$router.push({
                    name: tab_name,
                    params: {id: this.$route.params.id}
                });
            },
        },
        created() {
            this.$store.dispatch('GET_SUBSCRIBTIONS_PAYER', {
                id: this.$route.params.child_id
            });
        }
    }
</script>

<style scoped lang="sass">
    @import "../../../sass/variables"
    @import "../../../sass/cabinet"
    @import "../../../sass/teacherLesson"
    @import "../../../sass/teacherCheckwork"
    @import "../../../sass/studentStat"
    @import "../../../sass/teacherMaterials"
    @import "../../../sass/payer"
    @import "../../../sass/payerCommon"

    .pt-0
        padding-top: 0

    .pb-0
        padding-bottom: 0

    .justify-space-between
        justify-content: space-between

    .diary-navigation
        display: flex
        align-items: center
        justify-content: space-between

        .chat-head__search
            margin-left: 20px

</style>